// UI
import Dashboard from '@/components/dashboard/Dashboard'
import ScrollableScreen from '@/components/ui/ScrollableScreen'

export default function IndexPage() {
    return <Dashboard />
}
